export default __webpack_public_path__ + "static/media/zw.e97fa1ac.svg";